var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngineV1 } from '../apis';
const reqCases = collectionEngineV1('/cases');
export const getById = (id, casualConsistency) => reqCases('GET', `/${id}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const create = (c) => reqCases('POST', '/', { body: c });
export const patch = (id, data) => reqCases('PATCH', `/${id}`, { body: data });
export const merge = (fromCaseId, data) => reqCases('PATCH', `/${fromCaseId}/merge`, { body: data });
export const undoMerge = (caseId, updateId) => reqCases('PATCH', `/${caseId}/merge/undo/${updateId}`, {});
export const deleteCase = (id) => reqCases('DELETE', `/${id}`);
export const recognize = (searchStrings) => reqCases('POST', `/recognizer`, {
    body: { strings: searchStrings },
});
export const getAll = (caseFilter, offset, limit, filters, creditorId) => __awaiter(void 0, void 0, void 0, function* () {
    let query = '?';
    if (offset != undefined) {
        query = query + `offset=${offset}`;
    }
    if (limit != undefined) {
        query = query + `&limit=${limit}`;
    }
    if (creditorId != undefined) {
        query = query + `&creditorId=${creditorId}`;
    }
    return reqCases('POST', '/list' + query, {
        body: { caseFilter, filters },
    });
});
export const index = (id) => reqCases('POST', `/${id}/index`);
export const getInsightsTotals = () => reqCases('GET', `/insights/totals`);
//# sourceMappingURL=cases.js.map